import React from 'react';

import { InventoryTabItemName } from '../../../../../InventoryStore';
import { useInventoryState } from '../../../../../hooks';
import { useReadOnlyRowConfig } from '../../../../../hooks/useReadOnlyRowConfig';
import { isDateAfterEndOfSale, isDatePast } from '../../../../../utils';
import type { RoomOpeningInventory } from '../../../../../utils/rooms';
import { LabelCell } from '../../../../Table/Cells/LabelCell/LabelCell';
import { LabelValueCell } from '../../../../Table/Cells/LabelValueCell/LabelValueCell';
import { PureFieldCell } from '../../../../Table/Cells/PureFieldCell/PureFieldCell';
import { TableRow } from '../../../../Table/TableRow/TableRow';

const RoomBookingsRowComponent: React.FC<{ roomId: number }> = ({ roomId }) => {
  const { inventoryRooms, dateKeys } = useReadOnlyRowConfig(
    InventoryTabItemName.Rooms
  );

  const { endOfSaleDate } = useInventoryState();

  if (!inventoryRooms) {
    return null;
  }

  return (
    <TableRow>
      <LabelCell label="Bookings" />
      {dateKeys.map((dateKey) => {
        const bookedStockFieldName = [dateKey, `${roomId}`, 'bookedStock'];
        const isGrayed =
          isDatePast(dateKey) || isDateAfterEndOfSale(dateKey, endOfSaleDate);

        return (
          <PureFieldCell
            key={dateKey}
            name={bookedStockFieldName}
            dateKey={dateKey}
          >
            {(values?: RoomOpeningInventory) => {
              return (
                <LabelValueCell
                  value={values?.bookedStock ?? 0}
                  date={dateKey}
                  name={bookedStockFieldName}
                  grayed={isGrayed}
                />
              );
            }}
          </PureFieldCell>
        );
      })}
    </TableRow>
  );
};

export const RoomBookingsRow = React.memo(RoomBookingsRowComponent);
